import { useEffect } from "react";

/**
 * Añade listener para detectar si canvasSize excede container y muestra un alert (t opcional).
 */
export default function useCanvasResizeWarning(canvasSize, containerRef, t) {
  useEffect(() => {
    if (!canvasSize || !containerRef?.current) return;
    const handleResize = () => {
      const container = containerRef.current;
      if (!container) return;
      if (canvasSize.w > container.clientWidth || canvasSize.h > container.clientHeight) {
        if (t) alert(t("validation.screenSizeChange"));
        else alert("Screen size changed");
      }
    };
    window.addEventListener("resize", handleResize);
    // ejecutar la primera vez
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [canvasSize, containerRef, t]);
}